import Ground from "@object-generators/safety-barrier/objects/ground";

export default {
  type: Ground.types.FLAT,
  width: 1000,
  height: 1000,
  depth: 500
};



// WEBPACK FOOTER //
// ./src/reducers/options/ground/defaults/rebarReinforcement.js